export const FONTS = {
  classic: ["Classic", "Playfair Display", "Plus Jakarta Sans"],
  modern: ["Modern", "Space Grotesk", "DM Sans"],
  elegant: ["Elegant", "Cormorant Garamond", "Nunito Sans"],
  clean: ["Clean", "Outfit", "Outfit"],
  editorial: ["Editorial", "Fraunces", "Work Sans"],
  bold: ["Bold", "Syne", "Karla"],
};

export const THEMES = {
  modern_dark: { name: "Modern dark", primary_color: "#0F172A", accent_color: "#38BDF8", font: "modern", corners: "rounded", panel: "glass", tone: "dark", bar_style: "dark", pin_color: "#FFFFFF", pin_shape: "circle" },
  warm_classic: { name: "Warm classic", primary_color: "#3B2A20", accent_color: "#C8873A", font: "classic", corners: "rounded", panel: "solid", tone: "dark", bar_style: "brand", pin_color: "#FFF8EE", pin_shape: "circle" },
  clean_white: { name: "Clean white", primary_color: "#0F2A47", accent_color: "#14B8A6", font: "clean", corners: "pill", panel: "solid", tone: "light", bar_style: "light", pin_color: "#FFFFFF", pin_shape: "circle" },
  luxury_gold: { name: "Luxury gold", primary_color: "#111111", accent_color: "#D4A12A", font: "elegant", corners: "square", panel: "outline", tone: "dark", bar_style: "dark", pin_color: "#111111", pin_shape: "square" },
};

const loaded = new Set();
export function loadFont(key) {
  const f = FONTS[key];
  if (!f || key === "classic") return;
  [...new Set([f[1], f[2]])].forEach((name) => {
    if (loaded.has(name)) return;
    loaded.add(name);
    const l = document.createElement("link");
    l.rel = "stylesheet";
    l.href = `https://fonts.googleapis.com/css2?family=${name.replace(/ /g, "+")}:wght@400;500;600;700&display=swap`;
    document.head.appendChild(l);
  });
}

export const byOrder = (a, b) => (a.order || 0) - (b.order || 0) || (a.title || "").localeCompare(b.title || "", undefined, { numeric: true, sensitivity: "base" });
export const SECTION_KEYS = { builder: ["room", "spec"], fitness: ["room", "area", "spec"], energy: ["part", "spec"] };
const sec = (k) => (k === "finish" || k === "appliance" ? "spec" : k);
export const sectionRank = (skin) => {
  const o = skin?.menu_order || [];
  return (kind) => { const i = o.indexOf(sec(kind)); return i < 0 ? 99 : i; };
};

export function resolveSkin(builder, house) {
  const ov = house?.skin_override || null;
  const s = { primary_color: builder?.primary_color, accent_color: builder?.accent_color, ...(builder?.skin || {}), ...(ov || {}) };
  if (!s.menu_layout) s.menu_layout = s.rooms_panel === false ? "top" : "left";
  return s;
}

const rgb = (hex) => { const h = (hex || "#1E3A5F").replace("#", ""); const n = parseInt(h.length === 3 ? h.split("").map((c) => c + c).join("") : h, 16); return [(n >> 16) & 255, (n >> 8) & 255, n & 255]; };
const isLight = ([r, g, b]) => 0.299 * r + 0.587 * g + 0.114 * b > 160;

export function chatColors(s = {}) {
  const bg = s.chat_color || (s.tone === "color" ? s.panel_color : s.primary_color) || "#0F2A47";
  return { background: bg, color: isLight(rgb(bg)) ? "#0f172a" : "#ffffff" };
}

export function skinRootProps(s) {
  const f = FONTS[s.font] || FONTS.classic;
  loadFont(s.font);
  const pc = rgb(s.panel_color);
  const custom = s.tone === "color";
  return {
    "data-sk": "1",
    "data-sk-corners": s.corners || "rounded",
    "data-sk-panel": s.panel || "glass",
    "data-sk-tone": custom ? (isLight(pc) ? "color light" : "color") : s.tone || "dark",
    "data-sk-bar": s.bar_style || "brand",
    style: { "--sk-head": `"${f[1]}", Georgia, serif`, "--sk-body": `"${f[2]}", sans-serif`, ...(custom ? { "--sk-pc": pc.join(" ") } : {}) },
  };
}

export const barClass = (style) => ({ dark: "bg-slate-950/95", glass: "bg-slate-950/35 backdrop-blur-xl", light: "bg-white/95 text-slate-900" }[style] || "bg-bp/95");
